module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright1a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('em', [_vm._v("This book is for Patricia B")]), _vm._v(".,")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1b"
  }, [_c('em', [_vm._v("Blue-eyed Nebraska lady")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2a"
  }, [_c('em', [_vm._v("This book honors the memory of Arnold Gingrich")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2b"
  }, [_c('em', [_vm._v("Its publication was in part provided for by the")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2b"
  }, [_c('em', [_vm._v("men and women who were his colleagues at")]), _vm._v(" Esquire,")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2b"
  }, [_c('em', [_vm._v("the magazine he founded and edited with distinction")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06efab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0